import React, { Component } from 'react'
import css from './styles.scss'
import { connect } from 'react-redux'
import globalCss from '../../../scss/global.scss'
import { clearDataSourceEdit, updateDataSource, deleteDataSource, updateDataSourceName } from '../../actions/actions'

import DataSourceSpreadsheet from '../DataSourceSpreadsheet'

import datasource from '../lib/datasource'

const SPACE_CHAR = ' '
const NEWLINE_CHAR = '\n'

export class EditDataSource extends Component {
  constructor (props) {
    super(props)
    this.datasourceHelper = datasource.datasource
    this.state = {
      name: '',
      id: '',
      update: false,
      selected: false,
      addingColumn: false,
      rows: [],
      columns: [],
      isPromoted: false,
      lastPromoted: '',
      loading: false,
      editName: false,
      scroll: { x: 0, y: 0 }
    }
    this.field = null
    this.active = null
  }

  componentDidMount () {
    document.addEventListener('click', this.closeEditName, { capture: true })
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.closeEditName, { capture: true })
  }

  closeEditName = evt => {
    const { editName } = this.state
    if (editName && !evt.target.hasAttribute(['data-notoggle'])) {
      this.handleEditName()
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.modal === 'editSource' && nextProps.modal !== 'editSource') {
      this.setState({
        update: true
      }, () => {
        this.stopEditing()
      })
    }

    if (nextProps.item.editingDataSource === this.props.item.editingDataSource) {
      return
    }

    if (this.props.modal === 'editSource' && nextProps.modal === 'editSource') {
      this.updateSpreadsheet()
    }

    if (nextProps.item.editingDataSource) {
      const { item: { dataSources, editingDataSource } } = nextProps
      const source = dataSources[editingDataSource]
      this.setState({
        name: source.name,
        id: source.id,
        lastPromoted: source.modifiedAt,
        rows: this.getRows(source.data),
        update: false,
        selected: false,
        columns: source.columns
      })
      this.setState({
        loading: true
      }, () => {
        const id = this.props.item.editingDataSource
        this.getDataSourceCount(id).then(count => {
          this.setState({
            isPromoted: Boolean(count),
            loading: false,
            editName: false
          }, () => {
            if (this.state.name.includes('unnamed')) {
              this.handleEditName()
            }
          })
        })
      })
    }
  }

  getDataSourceCount (id) {
    if (!id) {
      return 0
    }
    return fetch(`/api/v1/data_sources/${id}/count`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.props.auth.bearerToken}`
      }
    })
      .then(res => {
        if (res.status === 200) {
          return res.json()
        }
        return {
          _error: res.statusText
        }
      }).then(data => {
        if (data._error) {
          return 0
        }
        return data.count
      }).catch(() => {
        return 0
      })
  }

  stopEditing = (backToItem = false) => {
    this.setState({
      loading: false,
      addingColumn: false,
      selected: false,
      editName: false,
      name: '',
      id: '',
      rows: [],
      scroll: { x: 0, y: 0 }
    })
    this.props.dispatch(clearDataSourceEdit())
    if (backToItem) {
      this.props.onClearModal()
    }
  }

  handleAddingColumn = () => {
    this.setState(prevState => ({ addingColumn: !prevState.addingColumn }), () => {
      if (this.state.addingColumn) {
        document.getElementById('column-input').focus()
      }
    })
  }

  handleAddColumn = submit => {
    submit.preventDefault()

    const { columns, rows } = this.state
    const enteredColumnName = document.getElementById('column-input').value.trim()

    if (enteredColumnName.length > 50) {
      return alert('Error: Column names can only be up to 50 character long.')
    }

    if (columns.includes(enteredColumnName)) {
      return alert('Error: A column already exists with that name')
    }

    if (!enteredColumnName.length) {
      return alert('Error: Column name is invalid')
    }

    if (columns.length === 50) {
      return alert('Error: Max columns is 50')
    };

    const appendedColumnName = rows.map(row => {
      row[enteredColumnName] = ''
      return row
    })

    this.setState(prevState => {
      return {
        columns: [...prevState.columns, enteredColumnName],
        rows: !columns.length ? [{ [enteredColumnName]: '' }] : appendedColumnName,
        addingColumn: false
      }
    }, () => this.save())
  }

  getRows = rows => {
    const newRows = rows.map(row => {
      return { ...row }
    })
    return newRows
  }

  handleAddRow = () => {
    this.setState(prevState => {
      return {
        rows: [...prevState.rows, {}]
      }
    })
  }

  handleOnFieldChange = (rowId, field, value) => {
    const { rows } = this.state
    const row = rows.find(({ _index }) => (_index === rowId))
    const originalValue = this.handleExtendedInput(value, SPACE_CHAR, NEWLINE_CHAR)
    if (row[field] === originalValue) {
      return
    }
    this.setState({
      rows: this.datasourceHelper.editCell(rows, rowId, field, originalValue)
    }, () => {
      this.save()
    })
  }

  handleOnRowSelection = index => {
    const { rows } = this.state
    const toggle = rows.find(({ _index }) => _index === Number(index))._checked
    this.setState({
      rows: this.datasourceHelper.editCell(rows, index, '_checked', !toggle)
    })
  }

  updateSpreadsheet = () => {
    this.setState({
      scroll: { x: 0, y: 0 },
      addingColumn: false,
      update: true
    }, () => {
      this.setState({
        update: false
      })
    })
  }

  rememberScroll = () => {
    const scrollX = document.getElementById('widthReference').scrollLeft
    const scrollY = document.querySelector('.SpreadsheetGridScrollWrapper_scrollable').scrollTop
    return { x: scrollX, y: scrollY }
  }

  handleOnDeleteColumn = name => {
    if (!confirm(`Confirm delete column ${name}?`)) return
    const scroll = this.rememberScroll()
    this.updateSpreadsheet()
    this.setState({
      rows: this.datasourceHelper.deleteColumn(this.state.rows, this.state.columns, name),
      columns: this.state.columns.filter(column => column !== name),
      selected: false,
      scroll
    }, () => {
      this.save()
    })
  }

  extendedField = input => {
    if (!this.state.selected) {
      this.setState({
        selected: true
      })
    }
    this.active = input
    this.field = document.getElementById('extended-field')
    this.field.value = this.handleExtendedInput(this.active.value, SPACE_CHAR, NEWLINE_CHAR)
    this.active.oninput = evt => {
      this.field.value = this.handleExtendedInput(evt.target.value, SPACE_CHAR, NEWLINE_CHAR)
    }
  }

  handleExtendedInput = (value, charToReplace, charToAdd) => {
    let newValue = ''
    for (const char of value) {
      if (char === charToReplace) newValue += charToAdd
      else newValue += char
    }
    return newValue
  }

  handleExtendedChange = evt => {
    this.active.value = this.handleExtendedInput(evt.target.value, NEWLINE_CHAR, SPACE_CHAR)
  }

  handleClearCell = () => {
    if (!this.state.selected) {
      return
    }
    this.field.value = ''
    this.handleReportValue()
  }

  handleReportValue = () => {
    const rowId = Number(this.active.parentElement.getAttribute('data-row'))
    const column = this.active.parentElement.getAttribute('data-column')
    this.handleOnFieldChange(rowId, column, this.field.value)
  }

  save = () => {
    const { item: { editingDataSource } } = this.props
    const { rows, columns } = this.state
    if (!editingDataSource || !rows.length) {
      return
    }
    const filteredRows = this.datasourceHelper.rowsForAPI(rows)
    this.props.dispatch(updateDataSource(editingDataSource, filteredRows, columns))
  }

  handlePromoteUpdate = () => {
    const { item: { editingDataSource, dataSources } } = this.props
    const { isPromoted } = this.state
    const dataSource = dataSources[editingDataSource]
    if (isPromoted) {
      // Update the data source
      if (editingDataSource) {
        fetch(`/api/v1/data_sources/${editingDataSource}`, {
          method: 'PUT',
          headers: {
            Authorization: `Bearer ${this.props.auth.bearerToken}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(dataSource)
        })
          .then(res => {
            if (res.status === 201) {
              return res.json()
            }

            return res.text()
          }).then(data => {
            if (typeof data === 'string') {
              alert(data)
            } else {
              this.setState({
                lastPromoted: data.modifiedAt
              })
              dataSource.modifiedAt = data.modifiedAt
            }
          }).catch(() => {
            alert('Failed to update the promoted data source. Please check your connection and try again.')
          })
      }
    } else {
      // Create the data source
      fetch('/api/v1/data_sources', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${this.props.auth.bearerToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataSource)
      })
        .then(res => {
          if (res.status === 201) {
            return res.json()
          }

          return res.text()
        }).then(data => {
          if (typeof data === 'string') {
            alert(data)
          } else {
            this.setState({ isPromoted: true, lastPromoted: data.modifiedAt })
          }
        }).catch(() => alert('Failed to promote data source. Please check your connection and try again.'))
    }
  }

  handleDelete = () => {
    if (!confirm(`Confirm delete data source ${this.state.name} from this item?`)) return
    const id = this.props.item.editingDataSource
    this.setState({
      update: true
    }, () => {
      this.props.dispatch(deleteDataSource(id))
      this.stopEditing(true)
    })
  }

  handleDeleteRowSelection = () => {
    const { rows } = this.state
    if (!rows.length) {
      return
    }
    if (this.field) {
      this.field.value = ''
    }
    const filteredRows = this.datasourceHelper.deleteSelectedRows(rows)
    const newRow = {}
    if (!filteredRows.length) {
      Object.keys(rows[0]).filter(key => !key.startsWith('_')).forEach(key => { newRow[key] = '' })
    }
    this.setState({
      rows: Object.keys(newRow).length ? [newRow] : filteredRows,
      selected: false
    }, () => {
      this.save()
    })
  }

  handleEditName = () => {
    const { id, name } = this.state
    this.setState(prevState => {
      return {
        editName: !prevState.editName
      }
    }, () => {
      if (this.state.editName) {
        const input = document.getElementById('ds-name-editor')
        input.focus()
        input.select()
      } else {
        this.props.dispatch(updateDataSourceName(id, name))
      }
    })
  }

  handleUpdateName = evt => {
    this.setState({
      name: evt.target.value
    })
  }

  handleEnter = evt => {
    if (evt.keyCode === 13) {
      this.handleEditName()
    }
  }

  render () {
    const { update, name, loading, isPromoted, rows, columns, addingColumn, scroll, lastPromoted, selected, editName } = this.state
    const { app: { secondaryColor } } = this.props
    const hasRowSelection = rows.some(row => row._checked)
    const d = new Date(parseInt(lastPromoted))
    const { item: { editingDataSource } } = this.props
    const loadingView = null
    let promoteDate = 'Not Promoted'

    if (isPromoted) {
      promoteDate = 'Promoted'
    }

    if (!isNaN(d.getTime())) {
      promoteDate = 'Promoted ' + d.toLocaleString()
    }

    let addColumnComponent
    if (addingColumn) {
      addColumnComponent = (
        <form autoComplete='off' onSubmit={this.handleAddColumn}>
          <input type='text' className={css.input} id='column-input' placeholder='Enter a Column Name...' />
          <button type='submit' className={css.btnAdd} style={{ backgroundColor: secondaryColor }}>Add</button>
          <button type='button' onClick={this.handleAddingColumn} className={css.btnAdd} style={{ backgroundColor: secondaryColor }}>Cancel</button>
        </form>
      )
    } else {
      addColumnComponent = (<button onClick={this.handleAddingColumn} className={css.btnAdd} style={{ backgroundColor: secondaryColor }}>Add Column</button>)
    }

    let nameEditor
    if (editName) {
      nameEditor = (
        <input
          className={css.nameInput}
          type='text'
          value={name}
          onChange={this.handleUpdateName}
          onKeyUp={this.handleEnter}
          data-notoggle
          id='ds-name-editor'
        />
      )
    } else {
      nameEditor = name
    }

    let bulkDeleteComponent
    if (hasRowSelection) {
      bulkDeleteComponent = (<button onClick={this.handleDeleteRowSelection} className={css.btnAdd} style={{ backgroundColor: secondaryColor }}>Delete Selected</button>)
    }

    if (!editingDataSource || update) {
      return null
    }

    if (loading) {
      return (
        <div className={css.bg}>
          <article className={css.wrapper}>
            <header className={css.header}>
              <h3 className={css.h3}>
              Loading....
              </h3>
            </header>
            <div className={css.content} />
          </article>
        </div>
      )
    }
    return (
      <div className={css.bg}>
        {loadingView}
        <article className={css.wrapper}>
          <header className={css.header}>
            <h3 className={css.h3}>
              <div className={css.inputWrapper}>
                  Data Source: {nameEditor} <i className={globalCss.iconEditCircle} onClick={this.handleEditName} data-notoggle style={{ cursor: 'pointer', marginLeft: '10px' }} title='Edit Name' />
              </div>
            </h3>
            <h4 className={css.h4}>
              {promoteDate}
              <div className={css.toolTip}>
                <i className={globalCss.iconHelpCircled} />
                <span className={css.toolTipText}>
                  <div className={css.helpText}>
                      Promote this data source to copy it to the project data sources section. This makes it possible for you to copy it to other items in the project.
                  </div>
                </span>
              </div>
            </h4>
          </header>
          <div className={css.topBar}>
            <div className={css.col1}>
              {addColumnComponent}
              {bulkDeleteComponent}
            </div>
            <div className={css.col2}>
              <button onClick={this.handleAddRow} className={css.btnAdd} style={{ backgroundColor: secondaryColor, visibility: columns.length ? 'visible' : 'hidden' }}>Add Row</button>
            </div>
          </div>
          <div className={css.topInput}>
            <i className={`${globalCss.iconX} ${css.inputX}`} onClick={this.handleClearCell} />
            <textarea
              type='text'
              className={css.extendedInput}
              onChange={this.handleExtendedChange}
              onBlur={this.handleReportValue}
              id='extended-field'
              disabled={!selected}
            />
          </div>
          <div className={css.content} id='widthReference'>
            <DataSourceSpreadsheet
              rows={this.datasourceHelper.rowsForSpreadsheet(rows)}
              columns={this.state.columns}
              onFieldChange={this.handleOnFieldChange}
              onRowSelection={this.handleOnRowSelection}
              onDeleteColumn={this.handleOnDeleteColumn}
              extendedField={this.extendedField}
              scroll={scroll}
            />
          </div>
        </article>
        <div className={css.bottomOptions}>
          <button onClick={this.handlePromoteUpdate} className={css.bottomBtn}>Promote Data Source</button>
          <button onClick={this.handleDelete} className={css.bottomBtn}>Delete Data Source</button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { app, auth, item, templates } = state
  return {
    app,
    auth,
    item,
    templates
  }
}

export default connect(mapStateToProps)(EditDataSource)



// WEBPACK FOOTER //
// /app/js/components/EditDataSource/index.js